import React from "react";
import { Link } from "gatsby";

function NavBarCompany({ mobile = false }) {
  let navMobileDropdownLink =
    "flex items-center py-4 text-sm font-medium text-gray-600 hover:text-gray-900";
  let columnLinksClassName =
    "flex gap-x-4 py-2 text-md text-rhoBlueDark-700 hover:text-rhoBlueLight-700 items-center";
  let liMobileClassName = "";

  const company = [
    {
      name: "About Us",
      href: null,
      link: "/about",
    },
    {
      name: "Impact",
      href: null,
      link: "/impact",
    },
  ];
  const people = [
    {
      name: "Our Team",
      href: null,
      link: "/our-team",
    },
    {
      name: "Careers",
      href: null,
      link: "/careers",
    },
    {
      name: "Benefits",
      href: null,
      link: "/benefits",
    },
  ];
  const resources = [
    {
      name: "News & Press",
      href: null,
      link: "/news",
    },
    {
      name: "Insights & Blog",
      href: null,
      link: "/insights",
    },
    {
      name: "Case Studies",
      href: null,
      link: "/case-studies",
    },
    {
      name: "Customer Stories",
      href: null,
      link: "/customers",
    },
  ];
  const highlights = [
    {
      title: "Forecast Climate Impact",
      href: "https://koi.eco/",
      link: null,
      imageUrl: "../images/heros-and-graphics/koi-laptop1.png",
      description:
        "Sign up for free to search data available in Koi. Instant access to the world's most authoritative energy and environmental data.",
      containerClasses: "bg-rhoBlueDark-100 p-2 rounded-lg",
    },
  ];

  // create a function that accepts required properties
  // it returns a list item with the link or href
  function createListItem(linkClassName, link, href, name) {
    return (
      <>
        {link ? (
          <Link to={link} className={linkClassName}>
            {name}
          </Link>
        ) : (
          <a
            href={href}
            className={linkClassName}
            target="_blank"
            rel="noreferrer"
          >
            {name}
          </a>
        )}
      </>
    );
  }

  if (mobile) {
    return (
      <ul>
        <ul>
          {resources.map((item, index) => (
            <li key={"resources-" + index} className={liMobileClassName}>
              {createListItem(
                navMobileDropdownLink,
                item.link,
                item.href,
                item.name
              )}
            </li>
          ))}
          {people.map((item, index) => (
            <li key={"people-" + index} className={liMobileClassName}>
              {createListItem(
                navMobileDropdownLink,
                item.link,
                item.href,
                item.name
              )}
            </li>
          ))}
          {company.map((item, index) => (
            <li key={"company-" + index} className={liMobileClassName}>
              {createListItem(
                navMobileDropdownLink,
                item.link,
                item.href,
                item.name
              )}
            </li>
          ))}
        </ul>
      </ul>
    );
  } else {
    return (
      <ul className="max-w-6xl px-5 mx-auto sm:px-6 align-middle">
        <li className="mx-auto grid grid-cols-4 gap-x-8 px-6 py-4 lg:px-8">
          <div className="grid col-span-3 grid-cols-3 gap-x-6 sm:gap-x-8">
            <div>
              <h3 className="text-md font-medium uppercase leading-6 text-rhoGray-500 border-b">
                Company
              </h3>
              <div className="mt-6 flow-root">
                <div className="-my-2">
                  {company.map((item, index) => (
                    <div key={index}>
                      {createListItem(
                        columnLinksClassName,
                        item.link,
                        item.href,
                        item.name
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div>
              <h3 className="text-md font-medium uppercase leading-6 text-rhoGray-500 border-b">
                People
              </h3>
              <div className="mt-6 flow-root">
                <div className="-my-2">
                  {people.map((item, index) =>
                    item.link ? (
                      <Link
                        key={index}
                        to={item.link}
                        className={`${columnLinksClassName}`}
                      >
                        {item.name}
                      </Link>
                    ) : (
                      <a
                        key={item.name}
                        href={item.href}
                        className={`${columnLinksClassName}`}
                      >
                        {item.name}
                      </a>
                    )
                  )}
                </div>
              </div>
            </div>
            <div>
              <h3 className="text-md font-medium uppercase leading-6 text-rhoGray-500 border-b">
                Resources
              </h3>
              <div className="mt-6 flow-root">
                <div className="-my-2">
                  {resources.map((item, index) =>
                    item.link ? (
                      <Link
                        key={index}
                        to={item.link}
                        className={`${columnLinksClassName}`}
                      >
                        {item.name}
                      </Link>
                    ) : (
                      <a
                        key={item.name}
                        href={item.href}
                        className={`${columnLinksClassName}`}
                      >
                        {item.name}
                      </a>
                    )
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="grid grid-cols-1 gap-10 sm:gap-8">
            <h3 className="sr-only">Recent posts</h3>
            {highlights.map((highlight, index) => (
              <article
                key={index}
                className={`relative isolate flex max-w-2xl flex-col gap-x-8 gap-y-6 sm:flex-row sm:items-start lg:flex-col lg:items-stretch ${highlight.containerClasses}`}
              >
                <div className="relative flex-none">
                  <div
                    className="w-full min-h-32 lg:h-auto bg-cover bg-center rounded-lg"
                    style={{
                      backgroundImage: `url(${
                        require("../images/heros-and-graphics/koi-laptop1.png")
                          .default
                      })`,
                    }}
                  ></div>
                </div>
                <div>
                  <h4 className="text-sm font-semibold">
                    {highlight.link ? (
                      <Link to={highlight.link}>
                        <span className="absolute inset-0" />
                        {highlight.title}
                      </Link>
                    ) : (
                      <a href={highlight.href} target="_blank" rel="noreferrer">
                        <span className="absolute inset-0" />
                        {highlight.title}
                      </a>
                    )}
                  </h4>
                  <p className="mt-2 text-sm leading-6">
                    {highlight.description}
                  </p>
                </div>
              </article>
            ))}
          </div>
        </li>
      </ul>
    );
  }
}

export default NavBarCompany;
